import React, { useEffect } from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from 'react-router-dom'
import { initFathom } from '../helpers/fathom'
import Home from './Home'

import ParentDashboard from './Auth/ParentDashboard'
import PrivacyPolicy from './Auth/PrivacyPolicy'
import TermsOfService from './Auth/TermsOfService'
import StudyRoom from './Auth/StudyRoom'
import ParentInviteClaim from './Auth/ParentInviteClaim'

import PrivateRoute from './PrivateRoute'
import ErrorBoundary from './ErrorBoundry'
import CustomSnackbarProvider from '../contexts/snackbar/CustomSnackbarProvider'
import { AuthProvider } from '../contexts/AuthContext'
import { ThemeProvider } from '../contexts/ThemeContext'
import WhatsNewModal from './WhatsNewModal'
import '../css/App.css'

function FathomAnalytics () {
  useEffect(() => {
    initFathom()
  }, [])
  return null
}

function App () {
  return (
    <ThemeProvider>
      <div className='App primary text-light'>
        <Router>
          <FathomAnalytics />
          <ErrorBoundary>
            <CustomSnackbarProvider>
              <AuthProvider>
                <WhatsNewModal />
                <Switch>
                  <Route exact path='/' component={Home} />

                  <PrivateRoute exact path='/parent/dashboard' component={ParentDashboard} />
                  <PrivateRoute exact path='/study-helper' component={StudyRoom} />
                  <Route exact path='/privacy-policy' component={PrivacyPolicy} />
                  <Route exact path='/terms-of-service' component={TermsOfService} />
                  <Route path='/invite/:token' component={ParentInviteClaim} />

                  <Route path='*' render={() => <Redirect to='/' />} />
                </Switch>
              </AuthProvider>
            </CustomSnackbarProvider>
          </ErrorBoundary>
        </Router>
      </div>
    </ThemeProvider>
  )
}

export default App
